import React from 'react'
import { PricingCard } from '@nile/components/src/Pages/Pricing'
import { Modal } from '@superops/ui-design-system'
import { COMMON_CONSTANTS, useProduct } from '@nile/components'
import { ItPlanContact } from '@nile/banyan/src/Pages/Protected/Configuration/Pricing/ITPlanContact'
import { useFlags } from 'launchdarkly-react-client-sdk'

const ProductPurchase = (props) => {
  const { active, handleClose, isTrailExpired } = props
  const flags = useFlags()
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP)
  return (
    <>
      <Modal
        open={active}
        onClose={() => handleClose(false)}
        extraLarge={isMSPProduct}
        large={flags?.itPricing}
        showCloseButton={false}
      >
        {isMSPProduct || flags?.itPricing ? (
          <PricingCard
            handleClose={handleClose}
            isTrailExpired={isTrailExpired}
          />
        ) : (
          <ItPlanContact />
        )}
      </Modal>
    </>
  )
}

export default ProductPurchase
